export default __webpack_public_path__ + "4f682161c2862d11976b6fa2358603fc.svg";